import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=4329e4bd&scoped=true"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"
import style0 from "./studentList.vue?vue&type=style&index=0&id=4329e4bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4329e4bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4329e4bd')) {
      api.createRecord('4329e4bd', component.options)
    } else {
      api.reload('4329e4bd', component.options)
    }
    module.hot.accept("./studentList.vue?vue&type=template&id=4329e4bd&scoped=true", function () {
      api.rerender('4329e4bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/studentList.vue"
export default component.exports